export default "__VITE_PUBLIC_ASSET__d26a3a1c__"